import { NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

// Name of icon will match name of svg file.
const icons = ['clear_filters'];

@NgModule()
export class RailProsIconsModule {
	constructor(
		private readonly iconRegistry: MatIconRegistry,
		private readonly sanitizer: DomSanitizer
	) {
		icons.forEach((iconName) => {
			this.iconRegistry.addSvgIcon(
				`${iconName}`,
				this.sanitizer.bypassSecurityTrustResourceUrl(
					`/admin-assets/${iconName}.svg`
				)
			);
		});
	}
}
